import { useAuth } from '../../../src/context/AuthContext';
import ReviewerSubmissionFlowScreen from '../../../src/screens/ReviewerSubmissionFlowScreen';
import OwnerSubmissionReviewScreen from '../../../src/screens/OwnerSubmissionReviewScreen';
import AdminSubmissionDisputeScreen from '../../../src/screens/AdminSubmissionDisputeScreen';

export default function SubmissionRoute() {
  const { user, activeMode } = useAuth();
  if (user?.role === 'ADMIN') return <AdminSubmissionDisputeScreen />;
  return activeMode === 'SHOP_OWNER' ? <OwnerSubmissionReviewScreen /> : <ReviewerSubmissionFlowScreen />;
}
